import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { useAttemptChanges } from '../attempt-changes';
import { useVisit } from '../visit';

// Opens an assigned questionnaire wherever it is offered, Tests or Today:
// without a draft it starts one at the first item; with a draft it resumes
// at the first unanswered item, or at the check once everything is answered.
// It settles once the screen has changed, and rejects with the service's
// sentence when a draft cannot be started. A draft started after the person
// has moved on stays started, to resume from Tests, but neither opens nor
// reports a failure on the screen they went to (#135).
export function useOpenAssignment() {
  const navigate = useNavigate();
  const { start } = useAttemptChanges();
  const capture = useVisit();

  return useCallback(function({ id, questionnaire, draft }) {
    if (draft == null) {
      const owns = capture();

      return start(id).then(function(attemptId) {
        if (owns() === true) {
          navigate(`/tests/${ attemptId }/1`);
        }
      }, function(failed) {
        if (owns() === true) {
          throw failed;
        }
      });
    }

    const answered = draft.answers.map(function({ position }) {
      return position;
    });
    const next = questionnaire.items.find(function({ position }) {
      return answered.includes(position) === false;
    });

    if (next == null) {
      navigate(`/tests/${ draft.id }/check`);

      return Promise.resolve();
    }

    navigate(`/tests/${ draft.id }/${ next.position }`);

    return Promise.resolve();
  }, [ start, navigate, capture ]);
}
